import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/minimum-payment-calculator',
  component: () => import('../../routes/MinimumPaymentCalculator.svelte'),
  card: {
    id: 'minimum-payment-calculator',
    title: 'Minimum Payment Calculator',
    description: 'See how making only minimum payments on your credit card keeps you in debt for decades. Compare minimum vs. custom payment strategies and calculate interest savings.',
    icon: 'credit_card_off',
    iconBgClass: 'bg-red-50',
    iconTextClass: 'text-red-600',
    href: '/minimum-payment-calculator',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Minimum Payment Calculator – See the True Cost of Minimum Credit Card Payments',
    description: 'Free minimum payment calculator to see how long it takes to pay off a credit card making only minimum payments. Calculate total interest paid and see how much you save by paying more.',
  },
};

export default meta;